// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// PAGE SCREENSHOT SCHEMA
/////////////////////////////////////////

export const PageScreenshotSchema = z.object({
  s3Bucket: z.string(),
  s3Key: z.string(),
  s3Etag: z.string(),
  s3Location: z.string(),
})

export type PageScreenshot = z.infer<typeof PageScreenshotSchema>

export default PageScreenshotSchema;
